module.exports = __webpack_public_path__ + "static/media/google-logo.45aebcf8.svg";